<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import Button from 'dashboard/components-next/button/Button.vue';
import { useMessageContext } from '../provider.js';
import { MESSAGE_TYPES } from '../constants';
import {
  isMasifiWaGroupMessage,
  isMasifiWaRunStart,
  masifiWaAuthorColor,
} from 'dashboard/helper/masifiWaGroups';

// Autor de un mensaje de grupo de WhatsApp QR (spec F3 §6.1, ruling 1): arriba, dentro de la burbuja, en el primer
// mensaje de cada racha del mismo autor. Entrante → nombre en color (abre el contacto); de un interno → "Equipo ·
// Nombre". La foto va en el slot nativo de avatar de 24 px de Message.vue (E2E fix 4, masifiWaGroupIncomingLayout).
// Montado en bubbles/Base.vue (import + 1 línea); todo sale del contexto del mensaje.
const { id, messageType, contentAttributes, sender } = useMessageContext();
const { t } = useI18n();
const router = useRouter();
const currentChat = useMapGetter('getSelectedChat');
const accountId = useMapGetter('getCurrentAccountId');

const author = computed(() => contentAttributes.value?.masifiWaAuthor || null);
const isTeam = computed(() => author.value?.team === true);
const isVisible = computed(() => {
  if (!isMasifiWaGroupMessage(contentAttributes.value)) return false;
  if (messageType.value !== MESSAGE_TYPES.INCOMING && !isTeam.value)
    return false;
  return isMasifiWaRunStart(currentChat.value?.messages, id.value);
});
const name = computed(() =>
  isTeam.value
    ? t('MASIFI_WHATSAPP_QR.GROUPS.AUTHOR.TEAM', {
        name: author.value?.name || '',
      })
    : sender.value?.name || author.value?.name || ''
);
const color = computed(() =>
  masifiWaAuthorColor(
    author.value?.lid || author.value?.phone || sender.value?.id
  )
);

const openContact = () => {
  if (isTeam.value || !sender.value?.id) return;
  router.push({
    name: 'contacts_edit',
    params: { accountId: accountId.value, contactId: sender.value.id },
  });
};
</script>

<template>
  <div
    v-if="isVisible"
    data-test="masifi-wa-group-author"
    class="flex items-center gap-1.5 mb-1 min-w-0"
  >
    <template v-if="isTeam">
      <span class="text-xs font-medium truncate text-n-slate-11">
        {{ name }}
      </span>
    </template>
    <Button v-else link xs :color="color" :label="name" @click="openContact" />
  </div>
</template>
